module.exports = __webpack_public_path__ + "f102ef0720cbf68b16820eff11593e38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-I-agree.png
// module id = 2064
// module chunks = 4